import { css, cx } from 'emotion';

import {
	headingLarge,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	textBlockLarger,
	museo500,
} from 'inside-out/global-styles';

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	position: 'relative',
});

export const bodyStyle = cx(
	textBlockLarger,
	css({
		maxWidth: '760px',
		img: {
			maxWidth: '100%',
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
		},
	})
);

export const ctaStyle = css({
	marginTop: '60px',
	'& > *': {
		marginTop: '30px',
	},
});

export const thumbnailStyle = css({
	marginBottom: '36px',
	'& img': {
		maxWidth: '100%',
	},
});

export const categoryTitleStyle = color =>
	css({
		fontSize: '22px',
		lineHeight: '26px',
		fontWeight: 300,
		color: color,
		marginTop: 0,
		marginBottom: '12px',
	});

export const titleStyle = cx(
	headingLarge,
	css({
		margin: '0 0 12px 0',
	})
);

export const dateStyle = css({
	...museo500,
	fontSize: '16px',
	lineHeight: '22px',
	margin: '0 0 36px 0',
});



// WEBPACK FOOTER //
// ./src/page-styles/news-and-events/detail/index.js